import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7c4974f0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  role: "list",
  class: "rounded-lg border divide-y divide-gray-100 bg-white"
}
const _hoisted_2 = { class: "heading" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center flex-none w-16" }, [
  /*#__PURE__*/_createElementVNode("label", null, "Active")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "min-w-0 flex-auto" }, [
  /*#__PURE__*/_createElementVNode("label", null, "User")
], -1))
const _hoisted_5 = {
  key: 0,
  class: "flex-none w-[160px]"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Role", -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 1,
  class: "flex-none w-[160px]"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "City", -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = {
  key: 2,
  class: "flex-none w-[160px]"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Declarant Type", -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = {
  key: 3,
  class: "flex-none w-[100px]"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Connections", -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-none w-[70px]" }, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-none w-14" }, " ", -1))
const _hoisted_19 = {
  key: 0,
  class: "no-data bg-white"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, "No users found", -1))
const _hoisted_21 = [
  _hoisted_20
]

import ListItem from "./list-item/list-item.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'list',
  props: {
	showHeader: {
		type: Boolean,
		default: true,
	},
	items: {
		type: Array as () => any[],
		default: () => [],
	},
	visibleItems: Array as () => string[],
	selectedUserId: String,
},
  emits: ["onDetailsClick", "onEditClick"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const hasField = (value: string) =>
	(props.visibleItems || []).indexOf(value) > -1;

const handleDetailsClick = (userId: string) => emit("onDetailsClick", userId);

const handleEditClick = (userId: string) => emit("onEditClick", userId);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("ul", _hoisted_1, [
      _createElementVNode("li", _hoisted_2, [
        _hoisted_3,
        _hoisted_4,
        (hasField('role'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
          : _createCommentVNode("", true),
        (hasField('city'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))
          : _createCommentVNode("", true),
        (hasField('declarantTypeLabel'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_13))
          : _createCommentVNode("", true),
        (hasField('connections'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, _hoisted_16))
          : _createCommentVNode("", true),
        _hoisted_17,
        _hoisted_18
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items || [], (item, index) => {
        return (_openBlock(), _createBlock(ListItem, {
          key: index,
          item: item,
          selectedItemId: __props.selectedUserId,
          visibleItems: __props.visibleItems,
          onOnDetailsClick: handleDetailsClick,
          onOnEditClick: handleEditClick
        }, null, 8, ["item", "selectedItemId", "visibleItems"]))
      }), 128))
    ]),
    (!__props.items || __props.items.length === 0)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_19, _hoisted_21))
      : _createCommentVNode("", true)
  ], 64))
}
}

})